import React from "react";
import StyledTooltip from "./StyledTooltip/StyledTooltip";
import { Eye, Pencil, Archive, Trash2, Download } from "lucide-react";
import { UndoOutlined } from "@ant-design/icons";

type IconName = "view" | "edit" | "archive" | "delete" | "unarchive" | "download";

interface CustomIconProps {
  name: IconName;
  tooltip?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  size?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  placement?: "top" | "bottom" | "left" | "right";
}

const iconMap: Record<IconName, React.ElementType> = {
  view: Eye,
  edit: Pencil,
  archive: Archive,
  delete: Trash2,
  unarchive: UndoOutlined,
  download: Download,
};

export const CustomIcon: React.FC<CustomIconProps> = ({
  name,
  tooltip,
  onClick,
  size = 18,
  color = "#141B34",
  className = "audience-actionbuttons",
  style = {},
  placement = "top",
}) => {
  const IconComponent = iconMap[name];
  if (!IconComponent) {return null;}

  const iconElement =
    name === "unarchive" ? (
      <img
        src="/Icons/unarchieve-icon.svg"
        alt="Unarchive"
        width={size}
        height={size}
        className={className}
        style={{ cursor: "pointer", ...style }}
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          e.stopPropagation();
          onClick?.(e);
        }}
      />
    ) : (
      <IconComponent
        size={size}
        style={{ color, cursor: "pointer", ...style }}
        className={className}
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          e.stopPropagation();
          onClick?.(e);
        }}
      />
    );

  return tooltip ? (
    <StyledTooltip content={tooltip} placement={placement}>
      <span>{iconElement}</span>
    </StyledTooltip>
  ) : (
    iconElement
  );
};
